var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserprofile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14012_76170)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5062 8.49394C44.0287 3.01657 36.7462 0 29 0C21.2538 0 13.9713 3.01657 8.49383 8.49394C3.01657 13.9713 0 21.2538 0 29C0 36.7462 3.01657 44.0287 8.49383 49.5061C13.9713 54.9834 21.2538 58 29 58C36.7462 58 44.0287 54.9834 49.5062 49.5061C54.9834 44.0287 58 36.7462 58 29C58 21.2538 54.9834 13.9713 49.5062 8.49394ZM29 54.6016C21.425 54.6016 14.6091 51.2935 9.91755 46.0476C12.826 38.3369 20.2715 32.8516 29 32.8516C23.3692 32.8516 18.8047 28.287 18.8047 22.6562C18.8047 17.0255 23.3692 12.4609 29 12.4609C34.6308 12.4609 39.1953 17.0255 39.1953 22.6562C39.1953 28.287 34.6308 32.8516 29 32.8516C37.7285 32.8516 45.174 38.3369 48.0825 46.0476C43.3909 51.2935 36.575 54.6016 29 54.6016Z",
    fill: "url(#paint0_linear_14012_76170)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14012_76170",
    x1: 1.5,
    y1: 32.5,
    x2: 61.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14012_76170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserprofile);
export default __webpack_public_path__ + "static/media/user profile.d464aa5757a84dad6bcd6a40734035e7.svg";
export { ForwardRef as ReactComponent };